/**
 * Offline Indicator Component (GRO-32)
 * Shows a banner when the app is offline
 */
import React, { useEffect } from 'react';
import useNetworkStore from '../../stores/useNetworkStore';
import './OfflineIndicator.css';

const OfflineIndicator = () => {
  const { isOnline, wasOffline, initNetworkListeners } = useNetworkStore();

  // Initialize network listeners on mount
  useEffect(() => {
    const cleanup = initNetworkListeners();
    return cleanup;
  }, [initNetworkListeners]);

  // Show "back online" message briefly
  if (wasOffline && isOnline) {
    return (
      <div className="network-indicator online">
        Back online - syncing...
      </div>
    );
  }

  // Show offline indicator
  if (!isOnline) {
    return (
      <div className="network-indicator offline">
        You're offline - changes will sync when connected
      </div>
    );
  }

  return null;
};

export default OfflineIndicator;
